import Vue from "vue";
import local from "../controller/continue/local";
import VueResource from 'vue-resource'
Vue.use(VueResource);

Vue.http.interceptors.push((request, next) => {
    let Local = new local();
    let userInfo =  is_json(Local.get('userInfo'))?JSON.parse(Local.get('userInfo')):'';
    let uid = userInfo.id?userInfo.id:0;
    request.headers.set('Token', Local.get('token')+'&'+uid+'&'+Local.get('time')); // 请求headers携带参数
    next(function (response) {
        if(response.data.code === 800){
            if(this.$route.name !=='webSign' && this.$route.name !=='weChartSign'){
                if(this.isWeChat()){
                    if(!localStorage.getItem('wxlogin') || time() - localStorage.getItem('wxlogin') > 30){
                        localStorage.setItem('wxlogin',time());
                        if(
                                (
                                        this.query('code')
                                        && localStorage.getItem('code')
                                        && localStorage.getItem('code') === this.query('code')
                                )|| (
                                        !this.query('code')
                                )
                        ){
                            localStorage.clear();
                            let path = window.location.href;
                            path = this.rebuildParams(path, {}, ['code']);
                            this.wechatSign(path);
                        }else{
                            localStorage.setItem('code',this.query('code'));
                        }
                    }
                }else{
                    localStorage.clear();
                    location.replace('/sign/sign?redirect_uri='+encodeURIComponent(window.location.href))
                }
            }
        }
        return response;
    });
});



// WEBPACK FOOTER //
// ./src/listen/request.js